<template>
  <div :id="`r-${item.id}`" class="w-fit flex flex-row items-start ml-12 mb-2 group">
    <div :class="[ 'mr-2 p-2 rounded-b-xl rounded-l-xl', item.id === selected ? 'bg-accent-dark' : 'bg-chat-supplier text-white' ]">
        <span class="w-fit inline-flex whitespace-nowrap relative top-0.5">
            <component
                :is="icon(1)"
                class="w-4 h-4 mt-0.5 text-orange hover:text-orange-hover"
            />
            <component
                :is="icon(2)"
                class="w-4 h-4 mt-0.5 text-orange hover:text-orange-hover"
            />
            <component
                :is="icon(3)"
                class="w-4 h-4 mt-0.5 text-orange hover:text-orange-hover"
            />
            <component
                :is="icon(4)"
                class="w-4 h-4 mt-0.5 text-orange hover:text-orange-hover"
            />
            <component
                :is="icon(5)"
                class="w-4 h-4 mt-0.5 text-orange hover:text-orange-hover"
            />
        </span>
        <span v-if="item.review" :class="[ 'px-1 text-sm prose max-w-none', item.id === selected ? '' : 'text-white' ]">
            {{ item.review }}
        </span>
        <span v-if="editable" v-tippy="$t('text-update-order-review')" class="ml-2" @click="$emit('edit', item)">
            <PencilIcon class="inline w-4 h-4 text-body group-hover:text-light cursor-pointer" />
        </span>
    </div>
    <div>
      <Avatar
        v-if="!_.isEmpty(supplier) && supplier?.name"
        :src="supplier?.logo"
        :class="navigable ? 'cursor-pointer' : ''"
        :title="supplier?.name"
        loading="lazy"
        @click="navigate"
      />
      <Avatar
        v-else
        :title="`${customer?.firstName} ${customer?.lastName}`.trim()"
      />
    </div>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { ROUTES } from "@utils/routes";
import Avatar from "@components/ui/avatar";
import StarIcon from "@components/icons/outline/star-icon";
import StarSolid from "@components/icons/solid/star-solid";
import PencilIcon from "@components/icons/pencil-icon";

const props = defineProps({
    supplier: {
        type: Object,
        default: () => { }
    },
    item: {
        type: Object,
        default: () => { }
    },
    selected: {
        type: Number,
        default: null
    },
    editable: {
        type: Boolean,
        default: true
    },
    navigable: {
        type: Boolean,
        default: true
    }
})

defineEmits(['edit']);

const { $eventBus } = useNuxtApp();

const icon = (value) => {
    return value <= (props.item?.score) ? StarSolid : StarIcon;
};

const navigate = async () => {
    if (!props.navigable) {
        return;
    }
    $eventBus.emit('modal:close');
    await navigatorTo(translatePath(ROUTES.CODE.SUPPLIER, slugify(props.supplier?.id, props.supplier?.name)));
}

</script>
